import { useVisibilityContext } from '@src/entities/User/ui/context/Visibility/Visibility';
import { isEmpty, isNil, isNull } from 'lodash';
import React, { useLayoutEffect } from 'react';

/**
 * Visibility
 *
 * Hides or shows children based on the visibility context.
 *
 * @param accessor
 * @param disabledEnvironments
 * @param disabledUserRoles
 * @param enabledEnvironments
 * @param enabledUserRoles
 * @param children
 * @returns {Element}
 * @constructor
 */
export function Visibility({
  accessor = '',
  children,
  disabledEnvironments = [],
  disabledUserRoles = [],
  enabledEnvironments = [],
  enabledUserRoles = [],
}) {
  const { handleVisibilityComponent, visibility: visibilityContext } = useVisibilityContext();

  /**
   * When the visibility status of a component changes, update the visibility context.
   */
  useLayoutEffect(() => {
    if (!isNil(accessor) && !isEmpty(accessor)) {
      handleVisibilityComponent(accessor, {
        disabledEnvironments,
        disabledUserRoles,
        enabledEnvironments,
        enabledUserRoles,
      });
    }
  }, [accessor, enabledEnvironments, disabledEnvironments, enabledUserRoles, disabledUserRoles]);

  if (
    isNull(visibilityContext?.components?.[accessor]?.status) ||
    visibilityContext?.components?.[accessor]?.status === 'disabled'
  ) {
    return <React.Fragment />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}
